module.exports = __webpack_public_path__ + "static/media/kt.df3b0e88.jpg";